<template>
  <el-popover
    placement="bottom-start"
    v-model="visible"
    width="800"
    trigger="click"
    class="m-l-10 m-r-10"
    :visible-arrow="false"
  >
    <div class="high-search advanced-class-query">
      <ly-form :formConfig="formConfig" :formKeys="formKeys" ref="lyForm" @change="change">
        <template v-slot:age="{ formData }">
          <el-input class="age-input" v-model.number="formData.min_age" placeholder="最小年龄"></el-input>
          <span class="m-10">至</span>
          <el-input class="age-input" v-model.number="formData.max_age" placeholder="最大年龄"></el-input>
        </template>
      </ly-form>
      <div class="btn-group">
        <el-button size="medium" @click="reset">重置</el-button>
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div>
    </div>
    <el-button slot="reference" type="primary" :size="size || 'medium'">
      高级查询
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
  </el-popover>
</template>
<script>
import { Popover, Input } from 'element-ui';
import { classSearchForm } from '@/utils/formConfigCommon';
import LyForm from '@/components/LyForm';

export default {
  name: 'AdvancedClassQuery',
  components: {
    ElPopover: Popover,
    LyForm,
    ElInput: Input
  },
  props: {
    size: {
      type: String
    },
    // 是否需要级别
    ifLevel: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      // formKeys: specializedSearchForm,
      formConfig: {
        'label-width': '70px',
        'label-position': 'left',
        ref: 'ly-form',
        inline: true,
        itemSpan: 12
      },
      visible: false
    };
  },
  computed: {
    formKeys() {
      const tmp = { ...classSearchForm };
      if (this.ifLevel) return tmp;
      delete tmp.fee_level_id;
      return tmp;
    }
  },
  methods: {
    async getData() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        data.specialized_subject_id = data.specialized_subject_id || data.specialized_subject_id_parent;
        delete data.specialized_subject_id_parent;
        delete data.specialized_subject_name;
        delete data.org_name;
        delete data.age;
        if (Array.isArray(data.class_date)) [data.class_start_date, data.class_end_date] = data.class_date;
        else {
          data.class_start_date = -1;
          data.class_end_date = -1;
        }
        delete data.class_date;
        delete data.specialized_subject_full_name;

        return data;
      }
      return null;
    },
    async search() {
      const data = await this.getData();
      if (data) this.$emit('search', { ...data });
      this.visible = false;
    },
    async change() {
      const data = await this.getData();
      if (data) this.$emit('change', { ...data });
    },
    async reset() {
      this.$refs.lyForm.resetFields();
      const data = {};
      Object.keys(this.formKeys).map(key => {
        if (key) data[key] = '';
        return key;
      });
      this.$emit('search', data);
    }
  }
};
</script>
<style lang="less">
.advanced-class-query.high-search {
  .el-input,
  .el-date-editor--daterange.el-input__inner {
    width: 300px;
    &.age-input {
      width: 132px;
    }
  }
  .el-range-separator {
    width: 30px;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
  }
  .el-input__validateIcon {
    display: none;
  }
}
</style>
